import { EmploymentType } from "@/interfaces/globals";
import { ProspectUserPositions } from "@/interfaces/prospect.interface";
import { env } from "@/lib/env";
import { enumToArray, enumToObj } from "@/lib/utils";

export const employmentTypeList = [
  {
    value: "PARTTIME",
    name: "Part Time",
    id: "PARTTIME",
  },
  {
    value: "FULLTIME",
    name: "Full Time",
    id: "FULLTIME",
  },
];

export const ProspectUserPositionsList = enumToArray(ProspectUserPositions);

export const EmploymentTypeObject = enumToObj(EmploymentType);
export const ManagerEmploymentTypeObject = [
  { key: "Part Time", value: "PARTTIME" },
  { key: "Full Time", value: "FULLTIME" },
];

export const positionList = [
  "Account",
  "Operation Manager",
  "Project Manager",
  "Sr. Project Manager",
  "Project Director",
  "Construction Manager",
  "Pre Construction Manager",
  "Managing Director",
  "Director",
  "General Manager",
  "Project Co-ordinator",
  "Project Administer",
];

export const States = [
  {
    name: "New South Wales",
    abbreviation: "NSW",
  },
  {
    name: "Victoria",
    abbreviation: "VIC",
  },
  {
    name: "Queensland",
    abbreviation: "QLD",
  },
  {
    name: "Tasmania",
    abbreviation: "TAS",
  },
  {
    name: "South Australia",
    abbreviation: "SA",
  },
  {
    name: "Western Australia",
    abbreviation: "WA",
  },
  {
    name: "Northern Territory",
    abbreviation: "NT",
  },
  {
    name: "Australian Capital Territory",
    abbreviation: "ACT",
  },
];

export const WeekDays = [
  { name: "Mon", value: "MONDAY" },
  { name: "Tue", value: "TUESDAY" },
  { name: "Wed", value: "WEDNESDAY" },
  { name: "Thu", value: "THURSDAY" },
  { name: "Fri", value: "FRIDAY" },
  { name: "Sat", value: "SATURDAY" },
  { name: "Sun", value: "SUNDAY" },
];

// donot change this order
export const dayNames = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export const classCount = [
  { id: "#project-detail", name: "Project Detail" },
  { id: "#waste-volume", name: "Waste Volume" },
  { id: "#resource-recovery", name: "Resource Recovery" },
  { id: "#recovery-breakdown", name: "Recovery Breakdown" },
] as const;

export enum EstimateActivityActions {
  CREATE = "CREATE",
  UPDATE = "UPDATE",
  SET_REVISION = "SET_REVISION",
  SET_FINAL = "SET_FINAL",
  SET_NOT_FINAL = "SET_NOT_FINAL",
  STATUS_CHANGED = "STATUS_CHANGED",
  DELETE = "DELETE",
  SYNCED = "SYNCED",
  MOVED = "MOVED",
  VERIFIED = "VERIFIED",
}

export const imgBaseUrl = `${env.FILES_BASE_URL}`;

export const enum OptionTypeConstants {
  "ESTIMATION_STATUS" = "ESTIMATION_STATUS",
  "ESTIMATION_SUBMISSION_METHOD" = "ESTIMATION_SUBMISSION_METHOD",
  "PO_STATUS" = "PO_STATUS",
  "CLAIM_STATUS" = "CLAIM_STATUS",
  "INVOICE_METHOD" = "INVOICE_METHOD",
  "Task & Claims" = "Task & Claims",
  "PROJECT_REGISTER_STATUS" = "PROJECT_REGISTER_STATUS",
  "DEAL_DESCRIPTION" = "DEAL_DESCRIPTION",
  "CONSTRUCTION_TYPE" = "CONSTRUCTION_TYPE",
  "ESTIMATION_TYPE" = "ESTIMATION_TYPE",
  "SOURCE" = "SOURCE",
  "INSPECTION" = "INSPECTION",
  "PROJECT_REGISTER_SUBMISSION_STATUS" = "PROJECT_REGISTER_SUBMISSION_STATUS",
}

// export type OptionTypesConstants =
//   (typeof OptionTypeConstants)[keyof typeof OptionTypeConstants];

export enum ClaimsOptions {
  PO_STATUS = "PO_STATUS",
  INVOICE_METHOD = "INVOICE_METHOD",
  CALM_STATUS = "CALM_STATUS",
}

export const allowedImageTypes = [
  "jpg",
  "jpeg",
  "png",
  "svg",
  "webp",
  "heic",
  "heif",
  "gif",
  "bmp",
  "tiff",
  "ico",
];
export const allowedFileTypes = ["pdf"];
export const allowedExcelTypes = ["xlsx", "xls", "csv"];
export const allowAllFileTypes = [...allowedImageTypes, ...allowedFileTypes];
export const allowedDocTypes = ["doc", "docx"];
export const allowedPptTypes = ["ppt", "pptx"];
export const allowedVideoTypes = ["mp4", "mov", "avi", "wmv", "flv"];

export const allowFileTypesMIME =
  "image/*,video/*,audio/*,application/pdf," +
  // Images
  "image/jpg,image/jpeg,image/png,image/webp,image/svg+xml,image/gif,image/heic,image/heif,image/bmp,image/tiff,image/x-icon," +
  // Videos
  "video/mp4,video/quicktime,video/x-msvideo,video/x-matroska,video/x-flv,video/x-ms-wmv,video/webm," +
  // Audio
  "audio/mpeg,audio/wav,audio/ogg,audio/aac,audio/flac,audio/mp4," +
  // Documents
  "application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document," +
  "application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet," +
  "application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation," +
  "text/plain,text/csv,application/vnd.oasis.opendocument.text,application/vnd.oasis.opendocument.spreadsheet," +
  "application/vnd.oasis.opendocument.presentation,text/rtf,text/markdown,text/tex," +
  // Design files
  "image/vnd.adobe.photoshop,image/vnd.adobe.illustrator,application/vnd.adobe.indesign," +
  "application/postscript,image/vnd.adobe.xd,image/figma,image/sketch,image/cdr," +
  "application/x-aseprite," +
  // Programming & Scripts
  "text/x-c,text/x-c++src,text/x-c-header,text/x-c++hdr,text/x-csharp,text/x-python," +
  "text/javascript,text/typescript,text/x-java-source,text/ruby,text/x-go,text/rust," +
  "text/swift,text/kotlin,text/x-kotlin,text/php,text/html,text/css,text/x-scss," +
  "text/x-sass,text/jsx,text/tsx,text/x-sh,text/x-bash,text/x-zsh,text/x-batch," +
  "text/x-powershell,text/json,text/xml,text/yaml,text/yml,text/toml,text/ini," +
  "text/env,text/config,text/tsconfig,text/eslintrc,text/prettierrc,text/lock," +
  "text/perl,text/lua,text/r,text/julia,text/asm,text/sql," +
  // Engineering & CAD
  "application/acad,application/dxf,application/revit,application/ifc," +
  "application/sketchup,application/step,application/stp,application/iges," +
  "application/sldprt,application/sldasm,application/ipt,application/iam," +
  "application/fusion360,application/obj,application/stl,application/3ds," +
  "application/blender,application/max,application/dae,application/fbx," +
  "application/x-t,application/x-b,sat/sab,application/cam,application/nc," +
  // Data files
  "text/tab-separated-values,application/parquet,application/feather,application/avro," +
  "application/db,application/sqlite,application/msaccess,application/sav," +
  "application/dta,application/mat,application/vnd.ms-excel.sheet.macroenabled.12," +
  "application/vnd.ms-excel.sheet.binary.macroenabled.12," +
  // Archives & Packages
  "application/zip,application/x-rar-compressed,application/x-7z-compressed," +
  "application/x-tar,application/gzip,application/x-bzip2,application/x-xz," +
  "application/gzip,application/x-tar+gzip,application/zstd,application/x-iso," +
  "application/x-dmg," +
  // Misc & Legal
  "application/vnd.android.package-archive,application/x-msdownload," +
  "application/x-msi,application/x-deb,application/x-rpm,application/octet-stream," +
  "application/octet-stream,application/legal,application/contract," +
  "application/agreement,application/law";

export const allowFileTypes =
  // MIME types for better browser compatibility
  "image/*,video/*,audio/*,application/pdf," +
  // Images
  ".jpg,.jpeg,.png,.webp,.svg,.gif,.heic,.heif,.bmp,.tiff,.ico," +
  // Videos
  ".mp4,.mov,.avi,.mkv,.flv,.wmv,.webm," +
  // Audio
  ".mp3,.wav,.ogg,.aac,.flac,.m4a," +
  // Documents
  ".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv,.odt,.ods,.odp,.rtf,.md,.tex," +
  // Design files
  ".psd,.ai,.indd,.eps,.xd,.fig,.sketch,.cdr,.affinity,.ase,.aseprite," +
  // Programming & Scripts
  ".c,.cpp,.h,.hpp,.cs,.py,.js,.ts,.java,.rb,.go,.rs,.swift,.kt,.kts,.php,.html,.htm,.css,.scss,.sass,.jsx,.tsx,.sh,.bash,.zsh,.bat,.cmd,.ps1,.json,.xml,.yaml,.yml,.toml,.ini,.env,.config,.tsconfig,.eslintrc,.prettierrc,.lock,.pl,.lua,.r,.jl,.asm,.sql," +
  // Engineering & CAD
  ".dwg,.dxf,.rvt,.ifc,.skp,.step,.stp,.igs,.iges,.sldprt,.sldasm,.ipt,.iam,.f3d,.obj,.stl,.3ds,.blend,.max,.dae,.fbx,.x_t,.x_b,.sat,.sab,.cam,.nc," +
  // Data files
  ".tsv,.parquet,.feather,.avro,.db,.sqlite,.accdb,.sav,.dta,.mat,.xlsm,.xlsb," +
  // Archives & Packages
  ".zip,.rar,.7z,.tar,.gz,.bz2,.xz,.tgz,.tar.gz,.zst,.iso,.dmg," +
  //email & messaging
  ".eml,.msg,.mht,.mhtml,.vcf," +
  // Legal
  ".legal,.contract,.agreement,.law";

export const maxFileSize = 2 * 1024 * 1024; // 2MB

export const WorkBreakDownOrder = [
  "Normal Hours",
  "Overnight Hours",
  "Weekend",
];

export const DEFAULT_GST = 10;
export const DEFAULT_MAX_CHARS = 10;
export const DEFAULT_MAX_VALUE = 9999999999;
export const DEFAULT_MAX_STR_CHARS = 10000;

//Number Constants
export const ZERO = 0;
export const NEGATIVE_ONE = -1;
export const ONE = 1;
export const TWO = 2;
export const THREE = 3;
export const FIVE = 5;
export const TEN = 10;
export const TWENTY = 20;
export const TWENTY_FIVE = 25;
export const THIRTY = 30;
export const FIFTY = 50;
export const SIXTY = 60;
export const EIGHTY = 80;
export const NINETY = 90;
export const HUNDRED = 100;
export const HUNDRED_FIFTY = 150;
export const THREE_HUNDRED = 300;
export const FIVE_HUNDRED = 500;
export const THOUSAND = 1000;
export const TEN_THOUSAND = 10000;

export const ONE_KB = 1024;
export const ONE_MB = 1024 * ONE_KB;
export const ONE_GB = 1024 * ONE_MB;

export const sortingAndSearchFilterParams = ["search", "sortBy", "orderBy"];

export const baseFilterParams = [
  "limit",
  "offset",
  "currentPage",
  ...sortingAndSearchFilterParams,
];

export const allowAllFileTypesExceptVideo = [
  ...allowedImageTypes,
  ...allowedFileTypes,
  ...allowedExcelTypes,
  ...allowedDocTypes,
  ...allowedPptTypes,
];
export const allowAllFileExceptImage = [
  ...allowedFileTypes,
  ...allowedExcelTypes,
  ...allowedDocTypes,
  ...allowedPptTypes,
  ...allowedVideoTypes,
];
